import { render, staticRenderFns } from "./lifeExpertList.vue?vue&type=template&id=632e5c7a&scoped=true&"
import script from "./lifeExpertList.vue?vue&type=script&lang=js&"
export * from "./lifeExpertList.vue?vue&type=script&lang=js&"
import style0 from "./lifeExpertList.vue?vue&type=style&index=0&id=632e5c7a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632e5c7a",
  null
  
)

export default component.exports